define.alias("shared/utils/time-slot-utils", "preview-grid/utils/time-slot-utils");